import { createSlice } from '@reduxjs/toolkit';

const searchSlice = createSlice({
    name: 'search',
    initialState: {
        keywords: '',
        categories: [],
        regions: [],
        categoriesText: '',
        regionsText: '',
    },
    reducers: {
        updateKeywords: (state, action) => {
            const update = action.payload;

            state.keywords = update;
        },
        updateFilter: (state, action) => {
            const updates = action.payload;
            state.categories = updates.categories;
            state.regions = updates.regions;
            state.categoriesText = updates.categoriesText;
            state.regionsText = updates.regionsText;
        },
        clearFilter: (state, action) => {
            state.categories = [];
            state.regions = [];
            state.categoriesText = '';
            state.regionsText = '';
        },
    },
});

export const {
    updateKeywords,
    updateFilter,
    clearFilter,
} = searchSlice.actions;

export default searchSlice.reducer;